import { render, staticRenderFns } from "./ThirdPartyPlatform.vue?vue&type=template&id=334fa6f2"
import script from "./ThirdPartyPlatform.vue?vue&type=script&lang=js"
export * from "./ThirdPartyPlatform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports